export const Reviews = () => {
  return (
    <section data-testid="reviews-section" className="border-b border-[#1e293b]/50 py-24">
      <div className="mx-auto max-w-6xl px-6">
        <div className="grid grid-cols-1 items-center gap-12 md:grid-cols-2">
          {/* Architecture verification frame */}
          <div
            data-testid="architecture-frame"
            className="rl-reveal relative overflow-hidden rounded-xl border border-[#1e293b] p-6 font-mono text-xs"
          >
            <img
              src="https://images.unsplash.com/photo-1571666521805-f5e8423aba9d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwxfHx0ZWNoJTIwYXJjaGl0ZWN0dXJlJTIwZGlhZ3JhbXxlbnwwfHx8fDE3OTI0MTgwNTd8MA&ixlib=rb-4.1.0&q=85"
              alt="Architecture diagram of persistent storage volume snapshot attached to isolated microvm"
              loading="lazy"
              className="absolute inset-0 h-full w-full object-cover opacity-20"
            />
            <div className="absolute inset-0 bg-gradient-to-br from-[#121c2b]/90 to-[#080d14]/95"></div>
            <div className="relative z-10">
              <div className="mb-2 font-bold text-[#22d3ee]">// ARCHITECTURE VERIFICATION</div>
              <p className="leading-relaxed text-[#94a3b8]">
                MicroVM isolation backed by Firecracker hypervisors ensuring
                zero cross-tenant memory leakage.
              </p>
              <div className="mt-4 flex items-center justify-between border-t border-[#1e293b] pt-4 text-[#64748b]">
                <span>Snapshots: ACTIVE</span>
                <span>Encrypted NVMe</span>
              </div>
            </div>
          </div>

          <div className="rl-reveal">
            <span className="font-mono text-xs uppercase tracking-widest text-[#64748b]">
              Community Reviews
            </span>
            <h2 className="mb-4 mt-1 text-2xl font-bold text-white md:text-3xl">
              Feedback from our early alpha builders
            </h2>
            <div
              data-testid="reviews-empty-state"
              className="rounded-xl border border-dashed border-[#1e293b] bg-[#0c121b]/60 p-6 text-sm text-[#94a3b8]"
            >
              Verified benchmark reports and testimonials from our initial
              developer cohort will be published here upon public launch.
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
